import type { Sha256Digest } from 'fredrick-data-contract';

export async function sha256Digest(bytes: Uint8Array): Promise<Sha256Digest> {
  const input = Uint8Array.from(bytes);
  const digest = await crypto.subtle.digest('SHA-256', input.buffer);
  const hex = [...new Uint8Array(digest)]
    .map((value) => value.toString(16).padStart(2, '0'))
    .join('');
  return `sha256:${hex}`;
}
